class Filter {
	constructor(group, id, name) {
		this._group = group;
		this._id = id;
		this._name = name;

		this._checkbox = UI.chk();
		onEv(this._checkbox, 'click', _ => document.dispatchEvent(new Event('filterSelected')));

		this._row = UI.div('py-1 px-2', [
				UI.label([
					this._checkbox,
					UI.span('ps-1', this._name)
				])
		]);
	}

	init(data) {
		if (data && data.hasOwnProperty(this._group)) {
		this._checkbox.checked = (this._id == -1 ? false : -1 < data[this._group].indexOf(this._id));
		}
		else {
			this._checkbox.checked = (this._id == -1);
		}
	}

	get group() {return this._group;}

	get id() {return this._id;}

	get row() {return this._row;}

	get isSet() {return this._checkbox.checked;}

	get isAll() {return this._id === -1;}

	set checked(value) {
		this._checkbox.checked = value;
	}

	get checked() {
		return this._checkbox.checked;
	}

	clear() {
		this.checked = false;
	}
}